<template>
  <li class="facet" @click="toggleFacet">
    <span class="mgt-spinner" v-if="facet.isLoading"></span>
    <span class="facet--remove" v-if="facet.isActive">&times;</span>

    <span class="facet--label">{{ facet.label || facet.name }}</span>
    <span class="facet--count">{{ facet.count }}</span>
  </li>
</template>

<script>
import {facetMixin} from "./mixins/facet-mixin";

export default {
  name: "Facet",
  mixins: [facetMixin]
}
</script>

<style lang="scss" scoped>

</style>